module.exports = __webpack_public_path__ + "static/media/slide1.7e6c5029.jpeg";